<template>

    <div>
        <div class="block-in-page">
            <div class="form-field">
                <label class="input-text-lbl">
                    Название папки
                    <span class="required" aria-required="true">*</span>
                </label>
                <input name="Name" type="text"
                       :class="['input-text', {'input-error': errors.has('Name')}]"
                       v-validate="'required'"
                       v-model="folder.Name">
                <span class="field-validation-valid">{{ errors.first('Name') }}</span>
            </div>

            <div class="form-field">
                <label class="input-text-lbl">
                    Описание
                </label>
                <textarea name="Description" style="height:150px" rows="10" class="input-memo"
                          v-model="folder.Description"></textarea>
                <span class="field-validation-valid">{{ errors.first('Description') }}</span>
            </div>
            <div class="form-field" v-if="parentFolders && parentFolders.length">
                <label class="input-text-lbl">
                    Родительская папка
                </label>
                <drop-down v-model="folder.ParentId"
                           :items="parentFolders"
                           :dataField="'Id'"
                           :textField="'Name'"></drop-down>
            </div>
        </div>
        <div class="block-in-page">
            <div class="flex">
                <image-setting :img="imgSite" :name="'site'" :parentImage="true" 
                               @onImageViewChanged="onImageViewChanged"
                               @onImageStyleParamsChanged="onImageStyleParamsChanged"></image-setting>
                <div class="form-field" style="width:300px;min-width:300px;margin-left:20px">
                    <div class="panel-block panel-block-new" style="margin-right:0">
                        <div class="panel-block-img-base">
                            <div class="panel-block-img">
                                <img :src="imgSitePath" alt="" :style="imageStyleFormatted" v-if="imgSitePath" />
                            </div>
                        </div>
                        <div class="panel-block-info">
                            <p class="panel-block-header margin-bottom-10">{{ folder.Name }}</p>
                            <p class="panel-body-desc" v-html="folder.DescriptionFormatted"></p>
                        </div>
                        <div class="panel-body-actions">
                            <button class="btn">Подробнее</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="block-in-page">
            <div class="flex">
                <image-setting :img="imgMobile" :parentImgPath="imgSitePath" :name="'mobile'"
                               @onImageViewChanged="onImageViewChanged"
                               @onImageStyleParamsChanged="onImageStyleParamsChanged"></image-setting>
                <div class="form-field" style="width:400px;min-width:400px;margin-left:20px">
                    <div class="panel-block panel-block-new panel-block-mobile" style="margin-right:0">
                        <div class="panel-block-img-base panel-block-img-mobile-folder">
                            <div class="panel-block-img panel-block-img-mobile-folder">
                                <img :src="imgMobilePath" alt="" :style="imageStyleMobileFormatted" v-if="imgMobilePath" />
                            </div>
                            <div class="panel-block-info">
                                <p class="panel-block-header margin-bottom-10">{{ folder.Name }}</p>
                                <p class="panel-body-desc" v-html="folder.DescriptionFormatted"></p>
                            </div>
                        </div>
                        <div class="panel-body-actions">
                            <button class="btn">Подробнее</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    

</template>

<script>
    import $ from 'jquery'
    import UI from '../helpers/ui-helpers'

    export default {
        name: "domain-folder",

        props: ['folder', 'folderPath', 'parentFolders'],

        data(){
            return {
                file: null,
                imgSitePath: null,
                imgSite: {
                    ImageStyle: this.folder.ImageStyle,
                    ImagePath: this.folder.Image,
                    Image: {}
                },
                imgMobilePath: null,
                imgMobile: {
                    ImageStyle: this.folder.ImageStyleMobile,
                    ImagePath: this.folder.ImageMobilePath,
                    Image: {}
                }
            }
        },

        computed:{
            imageStyleFormatted() {
                let settings = {
                    left: this.imgSite.ImageStyle.left + '%',
                    top: this.imgSite.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' +
                        this.imgSite.ImageStyle.translateX + '%)'
                };
                if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                    settings.height = this.imgSite.ImageStyle.size + '%';
                }
                if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                    settings.width = this.imgSite.ImageStyle.size + '%';
                }

                return settings;
            },

            imageStyleMobileFormatted() {
                let settings = {
                    left: this.imgMobile.ImageStyle.left + '%',
                    top: this.imgMobile.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' +
                        this.imgMobile.ImageStyle.translateX + '%)'
                };
                if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.height = this.imgMobile.ImageStyle.size + '%';
                }
                if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.width = this.imgMobile.ImageStyle.size + '%';
                }

                return settings;
            },
        },

        methods: {
            onImageViewChanged(imgPath, name) {
                if (name === 'site')
                    this.imgSitePath = imgPath;
                else
                    this.imgMobilePath = imgPath;
                this.$emit('update', this.imgSite, this.imgMobile,);
            },

            onImageStyleParamsChanged(imageStyle, name) {
                this.$emit('update', this.imgSite, this.imgMobile,);
            }
        },

        mounted() {
            let vm = this;
            vm.folder.ImageMobile = {};
            vm.imgMobile = {
                ImageStyle: vm.folder.ImageStyleMobile,
                ImagePath: vm.folder.ImageMobilePath,
                Image: {}
            };
            vm.imgSite = {
                ImageStyle: vm.folder.ImageStyle,
                ImagePath: vm.folder.Image,
                Image: {}
            };
        },

        destroyed(){
           
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/components/DomainFolder.vue